<script lang="ts">
  import { colors } from "../helpers/utils";
  // current color
  export let currentColor = colors[0];
  // cfd
  export let cfd: any;

  function setColor(color) {
    cfd.setDrawingColor(color);
    currentColor = color;
  }
</script>

<div class="action-bar__footer">
  {#if cfd}
    <div class="color-unit-wrapper">
      {#each colors as color}
        <div
          class="color-unit"
          style="background-color:{color};"
          class:active={color === currentColor}
          on:touchstart={() => setColor(color)}
          on:click={() => setColor(color)}
        />
      {/each}
    </div>
  {/if}
</div>

<style type="text/scss">
  @import "Footer";
</style>
